import React, { useEffect, useState } from 'react';
import { Accordion, Dropdown } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { uuid4 } from '../../libs/uuid4';
import { getAsync } from '../helper/axiosHelper';
import { useDispatch, useSelector } from 'react-redux';

const MainMenu = ({ handleCloseClick }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [data, setData] = useState([]);
  const [displayusername, displayusernameupdate] = useState('');
  const [isLogin, setIsLogin] = useState(false);
  const [epUserID, setEPUserID] = useState('');
  const [showMenu, ShowMenuUpdate] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/managementLogin') {
      ShowMenuUpdate(false);
    } else {
      ShowMenuUpdate(true);
    }
    let token = localStorage.getItem('token');
    let username = localStorage.getItem('userId');
    let id = localStorage.getItem('apid');
    setEPUserID(id);
  }, [location.pathname]);

  useEffect(() => {
    (async () => {
      const response = await getAsync('CMSMenu/GetCMSMenus');
      setData(response?.data);
    })();
  }, []);

  return (
    <>
      {!isLogin && (
        <>
          <Accordion collapseAll className="text-center !border-none">
            {data?.map((items, index) => (
              <Accordion.Panel key={index} className="bg-green-50">
                <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                  {t`(${isActive ? items?.ar_SA : items?.en_US.charAt(0).toUpperCase() + items?.en_US.slice(1)})`}
                </Accordion.Title>
                <Accordion.Content className={`p-2 text-left bg-white  ${isActive ? 'text-right ' : 'text-left '}`}>
                  {items?.childrens?.map((childItem, childIndex) => (
                    <ul key={childIndex} className="divide-y-2 ">
                      <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                        <Link
                          className="hover:text-customgreen"
                          to={`${childItem?.pageLink}/${childItem?.shjcApiID}`}
                          onClick={handleCloseClick}
                        >
                          {t`(${isActive ? childItem?.ar_SA : childItem?.en_US.charAt(0).toUpperCase() + childItem?.en_US.slice(1)})`}
                        </Link>
                      </li>
                    </ul>
                  ))}
                </Accordion.Content>
              </Accordion.Panel>
            ))}
          </Accordion>
        </>
      )}
    </>
  );
};

export default React.memo(MainMenu);
